const TOOLBAR_PY = 16; // px, vertical padding — kept in sync with toolbar.py below
const LOGO_HEIGHT = { xs: 40, md: 48 }; // kept in sync with logoButton.height below

// Total rendered AppBar height (logo height + the toolbar's own vertical
// padding) — exported so SectionAnchor can offset its scroll target by
// exactly this much instead of a hardcoded magic number that could silently
// drift out of sync with the actual bar height.
export const TOPBAR_HEIGHT = {
    xs: LOGO_HEIGHT.xs + TOOLBAR_PY * 2,
    md: LOGO_HEIGHT.md + TOOLBAR_PY * 2,
};

export const appBar = (scrolled) => ({
    background: scrolled ? 'rgba(1, 1, 52, 0.78)' : 'transparent',
    backdropFilter: scrolled ? 'saturate(160%) blur(14px)' : 'none',
    WebkitBackdropFilter: scrolled ? 'saturate(160%) blur(14px)' : 'none',
    borderBottom: '1px solid',
    borderColor: scrolled ? 'rgba(187, 188, 188, 0.12)' : 'transparent',
    boxShadow: 'none',
    transition: 'background 0.25s ease, backdrop-filter 0.25s ease, border-color 0.25s ease',
});

export const toolbar = {
    maxWidth: '1280px',
    width: '100%',
    mx: 'auto',
    px: { xs: 2, md: 4 },
    py: `${TOOLBAR_PY}px`,
    minHeight: 'unset',
    justifyContent: 'space-between',
};

export const logoButton = {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    p: 0,
    position: 'relative',
    height: LOGO_HEIGHT,
    display: 'flex',
    alignItems: 'center',
};

export const logoFull = (scrolled) => ({
    height: { xs: 36, md: 44 },
    width: 'auto',
    position: scrolled ? 'absolute' : 'relative',
    opacity: scrolled ? 0 : 1,
    transform: scrolled ? 'translateX(-4px)' : 'translateX(0)',
    transition: 'opacity 0.25s ease, transform 0.35s ease',
    pointerEvents: 'none',
});

export const logoSymbol = (scrolled) => ({
    height: { xs: 36, md: 40 },
    width: 'auto',
    position: scrolled ? 'relative' : 'absolute',
    opacity: scrolled ? 1 : 0,
    transform: scrolled ? 'translateX(0)' : 'translateX(4px)',
    transition: 'opacity 0.25s ease, transform 0.35s ease',
    pointerEvents: 'none',
});

export const nav = {
    display: 'flex',
    alignItems: 'center',
    gap: { xs: 1, sm: 1.5 },
};

const navButtonSize = {
    fontSize: { xs: '13px', sm: '16px' },
    padding: { xs: '8px 12px', sm: '9.6px 17.6px' },
    whiteSpace: 'nowrap',
    '@media (max-width: 359px)': {
        fontSize: '12px',
        padding: '8px 10px',
    },
};

export const navButton = {
    ...navButtonSize,
};

export const forBrandsButton = {
    display: 'inline-flex',
    ...navButtonSize,
};

export const navLabelFull = {
    display: { xs: 'none', md: 'inline' },
};

export const navLabelShort = {
    display: { xs: 'inline', md: 'none' },
};
